import { CircleCheckIcon } from '../../../../assets/icons';
import { Step, steps } from '../informations';
import styles from './ServiceRequestBreadcrumbs.module.scss';

const TOTAL_STEPS = 4;

interface ServiceRequestBreadcrumbsProps {
    step: Step;
    place: 'header' | 'main';
    isPaymentDisabled?: boolean;
}

const PAYMENT_STEP_INDEX = 3;

const ServiceRequestBreadcrumbs = ({ step, place, isPaymentDisabled }: ServiceRequestBreadcrumbsProps) => {
    const isDisabled = (i: number) => isPaymentDisabled && i === PAYMENT_STEP_INDEX;

    return (<div className={styles.container}>
        { place === 'header' ? <div className = { styles.breadcrumbs } >
    {
        Array.from({ length: TOTAL_STEPS }, (_, i) => (
            <div
                key={i}
                className={`${styles.step} ${i + 1 <= step.step && !isDisabled(i) ? styles.active : styles.disabled}`}
            />
        ))
    }
        </div >
        : <div className={styles.breadcrumbsContainer} >
    {
        Array.from({ length: TOTAL_STEPS }, (_, i) => (
            <div
                key={i}
                className={`${styles.stepMain} ${isDisabled(i) ? styles.stepDisabled : ''} ${!isDisabled(i) && i + 1 < step.step ? styles.completed : ''}
                ${!isDisabled(i) && i + 1 == step.step ? styles.stepActive : ''}`}
            >
                <div className={styles.stepNum}> {steps[i].step} </div>
                <div className={styles.stepName}> {steps[i].name} </div>
                {!isDisabled(i) && i + 1 < step.step && <span className={styles.completedBadge}>Completed</span>}

                </div>
        ))
    }
        </div >
       } </div>

    );
};

export default ServiceRequestBreadcrumbs;
